import { z } from "zod";
import { createCodec } from "../codec";

const CardApiSchema = z.object({
  card: z.string(),
  expiry: z.string(),
  year: z.string(),
  month: z.string(),
  code: z.string(),
  name_card: z.string(),
  msi: z.number().optional().nullable(),
  token_card: z.number().optional().nullable(),
  save_card: z.boolean().optional().nullable(),
});

const CardCodec = createCodec({
  apiSchema: CardApiSchema,
  deserialize: (api) => ({
    card: api.card,
    cvc: api.code,
    expiry: api.expiry,
    name: api.name_card,
    msi: api.msi,
    token: api.token_card,
    saveCard: api.save_card,
  }),
  serialize: (app) => {
    const expiry = app.expiry.replaceAll(" ", "");
    const expiryParts = expiry.split("/");

    return app.token
      ? {
          card: "",
          expiry: "",
          code: app.cvc,
          year: "",
          month: "",
          name_card: "",
          token_card: app.token,
          save_card: false,
        }
      : {
          card: app.card,
          expiry: expiry,
          code: app.cvc,
          year: expiryParts[1],
          month: expiryParts[0],
          name_card: app.name,
          msi: app.msi || undefined,
          save_card: app.saveCard,
        };
  },
});

type Card = z.output<typeof CardCodec.schema>;
type CardApi = z.input<typeof CardCodec.schema>;

export { CardCodec, type Card, type CardApi };
